import React, { useEffect, useState } from "react";
import "./PaymentStatus.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getStudentDetailsByAdmission, resetStudentSliceState, updateOrderStatus } from "../../redux/features/student/studentSlice";
import { resetPaymentStatusSliceState } from "../../redux/features/payment/payment.order.slice";
import { Spinner } from 'react-bootstrap'
import "./NativePaymentStatus.css"
import successGif from '../../assets/images/payment_success.gif'
import failedGif from '../../assets/images/payment_failed.gif'


const NativePaymentStatus = () => {

    const dispatch = useDispatch()

    const { admId, academicYear } = useParams()

    const [theArray, setTheArray] = useState([]);

    const orderDetails = useSelector(state => state.createOrder)

    const updatedDetails = orderDetails.updatePaymentDetails

    const userDetails = useSelector(state => state.student)

    const details = userDetails.getStudentDetailsByAdmissionDetails

    const payeeDetails = details?.data

    console.log("theArray.paymentStatus",theArray)

    useEffect(() => {
        dispatch(getStudentDetailsByAdmission({
            admission: admId,
            academicYear
        }))
    }, [])

    useEffect(() => {
        if (details.status === "succeeded" && payeeDetails) {
            payeeDetails?.termFee?.map((eachItem) => {
                if (Object.keys(eachItem)[0] === payeeDetails?.receipt) {
                    setTheArray(eachItem[payeeDetails?.receipt])
                }
            })
        }
        dispatch(updateOrderStatus("idle"))
    }, [details.status])

    useEffect(() => {
        if (updatedDetails.status === "succeeded") {
            dispatch(resetStudentSliceState())
            dispatch(resetPaymentStatusSliceState())
            window.location.reload(true)
        }
    }, [updatedDetails.status])

    return (
        <>
            {(details.status === "loading" || theArray.length === 0) ?
                <div style={{ minHeight: '80vh' }} className='d-flex justify-content-center align-items-center'>
                    <Spinner animation="border" role="status"></Spinner>
                </div>
                :
                <div className="paymentSuccessContainer">
                    <div className="paymentStatusCard">
                        <p className="statusText">{(theArray.paymentStatus === "Paid")? "Hurray!!! Payment Successfull" : "Oops! Your transaction has Failed"}</p>
                        {theArray.paymentStatus === "Paid" ?
                        <div className="imgContainer">
                            <img
                                src={successGif}
                                className='gifStyle'
                            /> 
                            </div> :
                            <div className="imgContainer">
                            <img
                                src={failedGif}
                                className="gifStyle"
                            />
                            </div>
                        }
                        <div className="subContainer">
                            <div className="orderDetailsContainer">
                                <p className="orderDetailsTitle">Order ID</p>
                                <span className="orderDetailsColon">:</span>
                                <p className="orderDetailsValue">{theArray.orderId}</p>
                            </div>
                            <div className="orderDetailsContainer">
                                <p className="orderDetailsTitle">Transaction ID</p>
                                <span className="orderDetailsColon">:</span>
                                <p className="orderDetailsValue">
                                    {theArray.transactionId}
                                </p>
                            </div>
                        <div className="orderDetailsContainer">
                            <p className="orderDetailsTitle">Amount</p>
                            <span className="orderDetailsColon">:</span>
                            <p className="orderDetailsValue">Rs {theArray.paidAmount ? theArray.paidAmount : theArray.amount}</p>
                        </div>
                        <div className="orderDetailsContainer">
                            <p className="orderDetailsTitle">Status</p>
                            <span className="orderDetailsColon">:</span>
                            <p className="orderDetailsValue">{theArray.paymentStatus}</p>
                        </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};
export default NativePaymentStatus;
